import { createContext } from "react";

const CloneCategoryContext = createContext({});

export default CloneCategoryContext;
